import { useMutation, useQueryClient } from "react-query";
import { createAdvertisement } from "api/services/advertisements";
import { EAdvertisementsQueryKeys } from "api/endpoints/advertisements";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import {
  TAdvertisement,
  TAdvertisementCreateBody,
} from "types/api/advertisement";

export const useCreateAdvertisement = () => {
  const queryClient = useQueryClient();
  return useMutation<TAdvertisement, TApiError, TAdvertisementCreateBody>(
    [EAdvertisementsQueryKeys.createAdvertisement],
    createAdvertisement,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          EAdvertisementsQueryKeys.getAdvertisements
        );
        queryClient.invalidateQueries(
          EAdvertisementsQueryKeys.getAdminAdvertisements
        );
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
